import React from 'react'

export default function Unauthorized(){
    return (
        <div className=' flex justify-center bg-slate-100 min-w-screen p-10 font-bold '> Unauthorized </div>
    )
}